<template>
  <!-- eslint-disable max-len -->
  <info>
    <h1>{{ $t("TERMS OF SERVICE") }}</h1>
    <div v-html="$t('TERMS_OF_SERVICE_DESC_1', {domain: BRAND_CONFIG.domain})"></div>
    <div v-html="$t('TERMS_OF_SERVICE_DESC_2')"></div>
    <html-with-links
      :html="
        $t('TERMS_OF_SERVICE_DESC_3', {
          privacyLink: '/info/privacy',
        })
      "
    ></html-with-links>
    <div v-html="$t('TERMS_OF_SERVICE_DESC_4')"></div>
    <div v-html="$t('TERMS_OF_SERVICE_DESC_5')"></div>
    <html-with-links
      :html="
        $t('TERMS_OF_SERVICE_DESC_6', {
          mailLink: 'mailto:appdb@protonmail.com',
        })
      "
    ></html-with-links>
  </info>
</template>

<script>
import Info from '@/components/Info';
import HtmlWithLinks from '@/components/HtmlWithLinks.vue';

export default {
  components: { Info, HtmlWithLinks },
  computed: {
    title() {
      return this.$t('TERMS OF SERVICE');
    },
  },
};
</script>
